<template>
<div>

<!-- Large modal -->
 <div v-if="visible" class="modal-backdrop-wrapper">

<div class="modal d-block" role="dialog" >
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header border-primary">
        
 
        <h4 class="modal-title" style="color:navy" id="exampleModalLabel"> 
          <i class="fas fa-bullhorn mr-2" aria-hidden="true"></i> 
          <strong>ARTICOLO CON CODICE <strong> <span style="color:red"> {{sku}}</span>   </strong>  GIA' ESISTENTE.</strong>  </h4>
              
      </div>

      <div class="modal-body">
        <spinner v-bind:spinner='spinner'></spinner>
        <h5><small>Doppio click seleziona prodotto.</small></h5>  
      <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

      <div class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

      <table class="table table-hover table-striped_ mb-0">
      <thead class="table-primary" >
          <tr>
          <th scope="col">ID</th>
          <th scope="col">CODICE</th>
          <th scope="col">BRAND</th>
          <th scope="col">CATEGORIA</th>
          <th scope="col">DESCRIZIONE</th>
          <th scope="col">REPARTO</th>
          <th scope="col">STAGIONE</th>
          <th scope="col">DATA REG.</th>
          <th scope="col">N.RO VARIANTI</th>
        
          </tr>
      </thead>
      <tbody>
      <tr :class="{ 'table-success': item.isExactMatch === 1 }"  data-toggle="tooltip" title="Doppio click seleziona Prodotto" class="pointer" v-on:dblclick="setProduct(item)" v-for="(item, index) in items[0]" :key="index">
      <td>{{item.productId}}</td>
      <td>{{item.sku}}</td>
      <td>{{item.brand}}</td>
      <td>{{item.category}}</td>
      <td>{{item.description}}</td>
      <td>{{item.department}}</td>
      <td>{{item.season}}-{{item.season_year}} </td>
      <td>{{item.create_at}} </td>
      <td>{{item.counter}} </td>
     
    </tr> 
  </tbody>
  </table>
  </div>

</div>





<div class="modal-footer">
        <button @click="close()" type="button" class="btn btn-primary">          
          CHIUDI
        </button>
        
        <div v-if="btn">
        <button @click="createProduct()"   type="button" class="btn btn-success" >
          <i class="fas fa-check-circle mr-2" aria-hidden="true"></i>   
          REGISTRA NUOVO PRODOTTO E PROCEDI</button>
        </div>
      </div>
    </div>
  </div>
</div>
  
 

</div>
</div>


</template>
<script>
import alertBox          from '@/components/common/AlertBox.vue';
import spinner           from '@/components/common/Spinner.vue';



import api               from '@/api'
import { mapGetters }    from 'vuex';


export default {
  
  components  : { alertBox, spinner },
  props : ['items',],
  data() {
    return {

      
      msg             : {
        title : '',
        body  : '',
        type  : 0      
      },
      visible    : false,
      

      spinner         : false ,
      btn             : false ,
      sku             : '' 
      
    };
  },
  computed :{

    ...mapGetters(['company']),
    
  },

  
  mounted: function() {},
  created: function() {
  },
  methods: {
    
    show()
    { 

      this.visible = true
      this.btn     = this.items[1].length == 0
      this.sku     = this.items[0][0].sku

    },
    close()
    {
      this.visible = false
    },
    createProduct()
    {
      
      this.$emit('createProduct')
      this.visible = false
    },
    async setProduct(product)
    {
     
      
      this.spinner = true          
      const sp = 'spProductBarcodes'
      
      const payload  = {sp,...product}
      
      

       try{

            const res = await api.post(payload)
        
            if (res.status !== 200) 
            {
                throw new Error(res.data ||  res)
            }
            
            product.barcodes = res.data.recordsets[0]
            this.spinner = false
            this.$emit('update',product)   
            this.visible = false

            //this.$refs.msgModal.close()
            
            

        }
        catch(err){

            this.spinner = false
            const msg = err.message
            //this.$refs.msgModal.show(msg)
            
            

        }



      

    },

    
    
    



  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position   : relative;
height     : 500px;
overflow   : auto;
}

.table-wrapper-scroll-y {
display: block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }


h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
p {
  font-family  : 'Roboto Condensed';
  font-size    : 28px;
  color        :darkgreen;
}

.modal-backdrop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050; /* sopra tutto */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5); /* backdrop semi-trasparente */
}

.modal.d-block {
  display: block;
  z-index: 1060; /* sopra il backdrop */
}

.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
.row-highlight {
  background-color: #f8f9fa;
  border-left: 4px solid #28a745;
}
.pointer:hover,
.pointer:hover td {
  background-color: blue !important;
  color: white;
  cursor: pointer;
}
</style>